/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.MembershipCancellation {
    angular.module("meevo.plugins.membershipCancellation", []);
}